/**
 * user-menu - sidebar menu
 *
 * dependencies: bootstrap-collapse and angular's jqLite (mini-jquery)
 * looks like jQuery only due to the selects
 *
 */
import angular from "angular";
import template from "./userMenu.html";

/* @ngInject */
export function userMenu($window, User, $location, _, flux, device) {
  return {
    scope: {},
    templateUrl: template,
    replace: true,
    link: function($scope) {
      var $ = $window.$;
      /**
       * hiding
       *
       * is done by toggling .menu-hidden on #bd
       */
      var userFolded;

      $scope.noUserMenu = !User.isUser();
      if (device.isPhone()) {
        $scope.noUserMenu = true;
      }
      // if page has no user menu on it
      if ($scope.noUserMenu) {
        flux.dispatch("set-page-store", { userMenu: false });
        return;
      }

      $scope.show = false;
      $scope.folded = false;
      $scope.activeSection = null;

      var bd = $("#content-wrap");
      var userMenuWrap = $("#userMenuWrap");

      function isSmall() {
        // $phone
        return device.clientWidth() < 768;
      }

      /**
       * user clicks to toggle sidebar
       */
      $scope.fold = function(way) {
        userFolded = angular.isDefined(way) ? way : !$scope.folded;
        foldSidebar(userFolded);
      };

      function foldSidebar(folding) {
        if ($scope.noUserMenu) {
          folding = true;
        }
        flux.dispatch("set-page-store", {
          userMenu: !folding
        });
        $scope.folded = folding;

        userMenuWrap.removeClass("hidden");
        bd.toggleClass("menu-hidden", folding);

        // trigger event because this changed the inner width
        // and other objects on page may resize for that width
        $($window).trigger("resize");
      }

      // call back from ajax-nav
      // $scope.mobileCloseOnClick = function() {
      //   $scope.$apply(function() {
      //     if (isSmall()) {
      //       $scope.fold(true);
      //     }
      //   });
      // };

      // auto hide on small screens
      function hider(force) {
        var should;
        // user has taken control by clicking
        if (angular.isDefined(userFolded)) {
          should = userFolded;
        } else {
          should = isSmall();
        }
        if (force || should !== $scope.folded) {
          foldSidebar(should);
        }
      }
      // initial show/hide
      hider(true);
      device.onResize(function() {
        hider(false);
      }, $scope);

      /**
       * open or close a menu section
       *
       * @param  {String} slug section slug
       * @param  {Boolean|undefined} way  boolean or undefined => toggle it
       */
      $scope.collapse = function(slug, way) {
        var cssid = "sub_" + slug,
          collapseMethod = angular.isUndefined(way)
            ? "toggle"
            : way ? "show" : "hide";

        // call bootstrap-collapse
        $("ul.collapse").each(function(i, it) {
          var $it = $(it);
          if (it.id === cssid) {
            $it.collapse(collapseMethod);
          } else {
            // only if its been opened/initialized
            // otherwise .collapse('hide') will open it
            if ($it.data("collapse")) {
              $it.collapse("hide");
            }
          }
        });
      };

      function openActiveSection() {
        if ($scope.activeSection) {
          // open this one if its not already open
          $scope.collapse($scope.activeSection, true);
        }
      }

      function updateUrl() {
        $scope.here = $location.path();
        angular.forEach($scope.items, function(item) {
          angular.forEach(item.items, function(sub) {
            if (sub.url === $scope.here) {
              $scope.activeSection = item.slug;
              return;
            }
          });
        });
        openActiveSection();
      }

      function init(menu) {
        if (!menu) {
          return;
        }

        $scope.items = _.map(menu.items, function(item) {
          var it = _.clone(item);
          it.header = it.items ? it.items.length : null;
          if (it.header) {
            it.subs = it.items;
          }
          return it;
        });

        // set the first item to the user's name
        $scope.items[0].title = menu.name;

        /**
         * is_admin
         * is_staff
         * name: full name of user
         * items:
         *   icon
         *   klass
         *   slug
         *   title
         *   url
         *   items:
         *     help
         *     icon
         *     klass
         *     slug
         *     title
         *     url
         *     items:
         *       always empty ?
         */

        bd.addClass("userMenued");

        // normal users have only one section which should always be open
        if (!menu.is_staff) {
          $scope.activeSection = "home";
          setTimeout(function() {
            $scope.collapse("home", true);
          }, 500);
        }
        updateUrl();
        $scope.show = !$scope.noUserMenu && $scope.items.length;
      }

      // may be immediate
      User.get(function() {
        init(User.data());
      });
      // user was loaded async
      flux.onChanged(
        "User",
        function() {
          init(User.data());
        },
        $scope
      );

      // on any page change
      flux.onChanged("url", updateUrl, $scope);

      // after the dom is added
      // can call bootstrap commands
      $scope.$evalAsync(openActiveSection);
    }
  };
}
